var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 26.25V17.691C12.1211 16.9032 12.7927 16.2645 13.6211 16.2645H18.1211C18.9495 16.2645 19.6211 16.9032 19.6211 17.691V26.25M15.0018 4.01396L5.25181 10.6075C4.85611 10.8751 4.62109 11.3083 4.62109 11.7701V24.1103C4.62109 25.292 5.62845 26.25 6.87109 26.25H24.8711C26.1137 26.25 27.1211 25.292 27.1211 24.1103V11.7701C27.1211 11.3083 26.8861 10.8751 26.4904 10.6075L16.7404 4.01397C16.2199 3.66201 15.5222 3.66201 15.0018 4.01396Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLight);
export default __webpack_public_path__ + "static/media/dashboard-light.becf389556175cda21c74057f93db9ff.svg";
export { ForwardRef as ReactComponent };